<form class="admin-filters" nz-form [formGroup]="searchForm" (ngSubmit)="submitFilterForm()">
  <div class="admin-filters__fields">
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            formControlName="searchTerm"
            nz-input
            [placeholder]="'admin.filter.search.placeholder' | translate"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span *ngIf="!searchForm.get('searchTerm')?.value" nz-icon nzType="search"></span>
          <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="searchForm.get('searchTerm')?.value"
            (click)="searchForm.get('searchTerm')?.setValue(null)"
          ></span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          class="mission-partner-filter"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.mission-partner.placeholder' | translate"
          formControlName="missionPartnerId"
        >
          <nz-option
            *ngFor="let option of missionPartnersWithActiveJobOffers"
            [nzLabel]="option.name"
            [nzValue]="option.id"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="admin-filters__field">
      <!-- mission partner for -->
      <nz-form-control>
        <nz-select
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.for-mission-partner.placeholder' | translate"
          formControlName="forMissionPartnerId"
        >
          <nz-option
            *ngFor="let option of missionPartnersWithActiveJobOffers"
            [nzLabel]="option.name"
            [nzValue]="option.id"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control>
        <label nz-checkbox formControlName="archived">
          <span>{{ "admin.filter.archived.label" | translate }}</span>
        </label>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control>
        <label nz-checkbox formControlName="published">
          <span>{{ "admin.filter.published.label" | translate }}</span>
        </label>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div class="admin-filters__actions">
    <nz-form-item>
      <nz-form-control>
        <button
          nz-button
          nzBlock
          nzType="default"
          type="button"
          [disabled]="isApiLoading"
          (click)="downloadJobOfferListCSV()"
        >
          <span nz-icon [nzType]="isApiLoading ? 'loading' : 'download'" nzTheme="outline"></span>
          {{ "admin.download.csv" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="primary" [disabled]="!searchForm.valid">
          {{ "admin.filter.submit" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button
          mhHasPermission="jo_list.write"
          nz-button
          nzType="default"
          type="button"
          (click)="openCreateJobOfferModal()"
        >
          {{ "admin.job-offer.add.label" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>

<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} of {{ total }} items
</ng-template>

<div class="desktop-only" *ngIf="(isMobileLayout$ | async) === false">
<nz-table
  class="sticky-table"
  #basicTable
  [nzData]="tableState.data?.items || []"
  nzPaginationPosition="both"
  nzShowSizeChanger="true"
  nzSize="small"
  [nzShowTotal]="rangeTemplate"
  nzFrontPagination="false"
  [nzLoading]="tableState.loading"
  [nzTotal]="tableState.data?.paging?.items || 0"
  [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
  [nzPageIndex]="tableState.data?.paging?.page || 0"
  [nzScroll]="{ x: '1200px' }"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th nzColumnKey="NAME" [nzSortFn]="true">{{ "admin.name.title" | translate }}</th>
      <th>{{ "admin.mission-partner.title" | translate }}</th>
      <th [nzWidth]="'200px'">{{ "admin.for-mission-partner.title" | translate }}</th>
      <th [nzWidth]="'200px'">{{ "admin.stage.title" | translate }}</th>
      <th>{{ "admin.domain-expertise.title" | translate }}</th>
      <th>{{ "admin.salary.title" | translate }}</th>
      <th>{{ "admin.matched-amount.title" | translate }}</th>
      <th nzColumnKey="REG_TIMESTAMP" [nzSortFn]="true" nzSortOrder="descend">
        {{ "admin.creation-timestamp.title" | translate }}
      </th>
      <th>{{ "admin.action.title" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of basicTable.data">
      <td>
        <nz-spin *ngIf="data.status === JobOpportunitySearchResultStatus.PENDING" nzSimple [nzSize]="'small'"></nz-spin>
        <a [routerLink]="['/admin/job-offer-matches', data.id]" target="_blank">
          {{ data.name }}
        </a>
      </td>
      <td>
        <a [routerLink]="['/admin/mission-partner-view', data.missionPartnerId]" target="_blank">
          {{ data.missionPartnerName }}
        </a>
      </td>

      <td>
        <nz-select
          *ngIf="canWrite"
          nzShowSearch
          [nzOptions]="missionPartnerOptions"
          [nzPlaceHolder]="'admin.for-mission-partner.placeholder' | translate"
          [ngModel]="data.forMissionPartnerId"
          (ngModelChange)="setJobOpportunityForMissionPartner(data.id, $event)"
          style="width: 100%"
        ></nz-select>
      </td>

      <td>
        <nz-select
          *ngIf="canWrite"
          nzShowSearch
          [nzOptions]="(stageOptions$ | async) || []"
          [nzPlaceHolder]="'admin.stage.placeholder' | translate"
          [ngModel]="data.stage"
          (ngModelChange)="setJobOpportunityStage(data.id, $event)"
          style="width: 100%"
        ></nz-select>
      </td>
      <td>
        <mh-tags-output [value]="data.domainExpertise"></mh-tags-output>
      </td>
      <td>{{ data.salaryExpectations?.min?.name }} - {{ data.salaryExpectations?.max?.name }}</td>
      <td>{{ data.matchedAmount }}</td>
      <td>
        <div class="nowrap">{{ data.creationTimestamp | date : "yyyy-MM-dd" }}</div>
        <div class="nowrap">{{ data.creationTimestamp | date : "HH:mm:ss" }}</div>
      </td>
      <td class="nowrap">
        <button
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.sign-in-as.tooltip' | translate"
          (click)="onSignInAs(data.missionPartnerId)"
        >
          <span nz-icon nzType="login" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="data.id"
          (click)="copyId(data.id)"
        >
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite"
          [disabled]="data.archived"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="(data.archived ? 'archived.label' : 'archive.button') | translate"
          (click)="showArchiveConfirm(data)"
        >
          <span nz-icon nzType="container" nzTheme="outline"></span>
        </button>
        <ng-container *ngIf="isJobOpportunityPublishingEnabled">
          <button
            *ngIf="canWrite && !data.published"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'job-opportunity.publish.tooltip' | translate"
            (click)="publishJobOpportunity(data.id)"
          >
            <span nz-icon nzType="file-text" nzTheme="outline"></span>
          </button>
          <button
            *ngIf="canWrite && data.published"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'job-opportunity.unpublish.tooltip' | translate"
            (click)="unpublishJobOpportunity(data.id)"
          >
            <span nz-icon nzType="file-text" nzTheme="fill"></span>
          </button>
        </ng-container>
        <button
          *ngIf="canWrite"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'Edit'"
          (click)="editJobOffer(data.id)"
        >
          <span nz-icon nzType="edit" nzTheme="outline"></span>
        </button>
        <button
          *ngIf="canWrite"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'delete.button' | translate"
          (click)="showDeleteConfirm(data)"
        >
          <span nz-icon nzType="delete" nzTheme="outline"></span>
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>
</div>

<div class="mobile-only" *ngIf="isMobileLayout$ | async" style="margin-top: 16px;">
  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-bottom: 16px; text-align: center;"
  ></nz-pagination>

  <nz-spin [nzSpinning]="tableState.loading">
    <div style="display: flex; flex-direction: column; gap: 16px;">
      <nz-card *ngFor="let data of tableState.data?.items || []" nzHoverable nzSize="small">
        <nz-row [nzGutter]="[0, 8]">
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.name.title" | translate }}:</strong>
            <div>
              <nz-spin *ngIf="data.status === JobOpportunitySearchResultStatus.PENDING" nzSimple [nzSize]="'small'"></nz-spin>
              <a [routerLink]="['/admin/job-offer-matches', data.id]" target="_blank">
                {{ data.name }}
              </a>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.mission-partner.title" | translate }}:</strong>
            <div>
              <a [routerLink]="['/admin/mission-partner-view', data.missionPartnerId]" target="_blank">
                {{ data.missionPartnerName }}
              </a>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.for-mission-partner.title" | translate }}:</strong>
            <div>
              <nz-select
                *ngIf="canWrite"
                nzShowSearch
                [nzOptions]="missionPartnerOptions"
                [nzPlaceHolder]="'admin.for-mission-partner.placeholder' | translate"
                [ngModel]="data.forMissionPartnerId"
                (ngModelChange)="setJobOpportunityForMissionPartner(data.id, $event)"
                style="width: 100%"
              ></nz-select>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.stage.title" | translate }}:</strong>
            <div>
              <nz-select
                *ngIf="canWrite"
                nzShowSearch
                [nzOptions]="(stageOptions$ | async) || []"
                [nzPlaceHolder]="'admin.stage.placeholder' | translate"
                [ngModel]="data.stage"
                (ngModelChange)="setJobOpportunityStage(data.id, $event)"
                style="width: 100%"
              ></nz-select>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.domain-expertise.title" | translate }}:</strong>
            <div>
              <mh-tags-output [value]="data.domainExpertise"></mh-tags-output>
            </div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.salary.title" | translate }}:</strong>
            <div>{{ data.salaryExpectations?.min?.name }} - {{ data.salaryExpectations?.max?.name }}</div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.matched-amount.title" | translate }}:</strong>
            <div>{{ data.matchedAmount }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.creation-timestamp.title" | translate }}:</strong>
            <div>{{ data.creationTimestamp | date : "yyyy-MM-dd HH:mm:ss" }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <nz-divider style="margin: 8px 0;"></nz-divider>
            <strong>{{ "admin.action.title" | translate }}:</strong>
            <div style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 8px;">
              <button nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.sign-in-as.tooltip' | translate" (click)="onSignInAs(data.missionPartnerId)">
                <span nz-icon nzType="login" nzTheme="outline"></span>
                {{ "admin.sign-in-as.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" [attr.data-tooltip]="data.id" (click)="copyId(data.id)">
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                Copy ID
              </button>
              <button *ngIf="canWrite" [disabled]="data.archived" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="(data.archived ? 'archived.label' : 'archive.button') | translate" (click)="showArchiveConfirm(data)">
                <span nz-icon nzType="container" nzTheme="outline"></span>
                {{ (data.archived ? "archived.label" : "archive.button") | translate }}
              </button>
              <ng-container *ngIf="isJobOpportunityPublishingEnabled">
                <button *ngIf="canWrite && !data.published" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'job-opportunity.publish.tooltip' | translate" (click)="publishJobOpportunity(data.id)">
                  <span nz-icon nzType="file-text" nzTheme="outline"></span>
                  {{ "job-opportunity.publish.tooltip" | translate }}
                </button>
                <button *ngIf="canWrite && data.published" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'job-opportunity.unpublish.tooltip' | translate" (click)="unpublishJobOpportunity(data.id)">
                  <span nz-icon nzType="file-text" nzTheme="fill"></span>
                  {{ "job-opportunity.unpublish.tooltip" | translate }}
                </button>
              </ng-container>
              <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'Edit'" (click)="editJobOffer(data.id)">
                <span nz-icon nzType="edit" nzTheme="outline"></span>
                Edit
              </button>
              <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'delete.button' | translate" (click)="showDeleteConfirm(data)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
                {{ "delete.button" | translate }}
              </button>
            </div>
          </nz-col>
        </nz-row>
      </nz-card>
    </div>
  </nz-spin>

  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-top: 16px; text-align: center;"
  ></nz-pagination>
</div>
